import * as types from '../actions/ActionTypes';

const initialState = {
  loading: false,
  appraisalsList: [],
  appraisalRecord: null,
  redirect_to_list: false,
  validation_error: "",
  showUpdateForm: false,
  showViewPage: false,
  showCategorySetupWindow: false,
  // Appraisal Progress
  appraisalProgressList: [],
  appraisalProgressRecord: null,
  showAppraisalProgressUpdateForm: false,
  showMonthlyAppraisalViewPage: false,
  // Activity Logs
  activityLogs: {}, // { appraisalProgressId: { logs: [], pagination: {} } }
  activityLogsLoading: false,
  activityLogsError: null,
  myPafsList: [],
  myPafRecord: null,
};

const AppraisalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.APPRAISALS_REQUEST:
      return { ...state, loading: true, redirect_to_list: false };
    case types.APPRAISALS_SUCCESS:
      return { ...state, loading: false, appraisalsList: action.appraisalsList };
    case types.APPRASIAL_SHOW_CATEGORY_SETUP_WINDOW: 
      return { ...state, showCategorySetupWindow: action.showCategorySetupWindow };
    case types.APPRAISALS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        appraisalRecord: action.record,
        showUpdateForm: action.actionType === 'update',
        showViewPage: action.actionType === 'view',
      };
    case types.APPRAISALS_VALIDATION_ERROR:
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.APPRAISALS_REDIRECT_TO_LIST:
    case types.APPRAISALS_RESET_SETUP_FLOW:
      return {
        ...state,
        showCategorySetupWindow: false,
        redirect_to_list: false,
        showUpdateForm: false,
        showViewPage: false,
        appraisalRecord: null,
        validation_error: "",
      };
    case types.APPRAISALS_CLEAR_LIST_REDIRECT:
      return {
        ...state,
        redirect_to_list: false,
      };
    // Appraisal Progress cases
    case types.APPRAISAL_PROGRESS_REQUEST:
      return { ...state, loading: true };
    case types.APPRAISAL_PROGRESS_SUCCESS:
      return { ...state, loading: false, appraisalProgressList: action.appraisalProgressList || [] };
    case types.APPRAISAL_PROGRESS_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        appraisalProgressRecord: action.record,
        showAppraisalProgressUpdateForm: action.actionType === 'update',
        showMonthlyAppraisalViewPage: action.actionType === 'view',
      };
    case types.APPRAISAL_PROGRESS_VALIDATION_ERROR:
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.APPRAISAL_PROGRESS_RESET_FLAGS:
      return {
        ...state,
        showAppraisalProgressUpdateForm: false,
        showMonthlyAppraisalViewPage: false,
      };
    case types.APPRAISAL_PROGRESS_RESET_RECORD:
      return {
        ...state,
        loading: false,
        appraisalProgressRecord: null,
        showAppraisalProgressUpdateForm: false,
        showMonthlyAppraisalViewPage: false,
        validation_error: "",
      };
    case types.APPRAISAL_PROGRESS_SUBMIT_SUCCESS:
    case types.APPRAISAL_PROGRESS_APPROVE_SUCCESS:
    case types.APPRAISAL_PROGRESS_REJECT_SUCCESS:
      return {
        ...state,
        loading: false,
        appraisalProgressRecord: action.record || state.appraisalProgressRecord,
      };
    case types.MY_PAFS_REQUEST:
      return { ...state, loading: true };
    case types.MY_PAFS_SUCCESS:
      return { ...state, loading: false, myPafsList: action.myPafsList || [] };
    case types.MY_PAFS_GET_SUCCESS:
      return { ...state, loading: false, myPafRecord: action.record || null };
    case types.MY_PAFS_SIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        myPafRecord: action.record || state.myPafRecord,
        myPafsList: state.myPafsList.map((row) =>
          row.id === action.record?.id ? { ...row, ...action.record } : row
        ),
      };
    case types.MY_PAFS_VALIDATION_ERROR:
      return { ...state, loading: false, validation_error: action.validation_error };
    case types.MY_PAFS_RESET_RECORD:
      return { ...state, myPafRecord: null };
    case types.MY_PAFS_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        myPafsList: (state.myPafsList || []).filter(
          (row) => String(row?.id) !== String(action.id)
        ),
        myPafRecord:
          String(state.myPafRecord?.id) === String(action.id) ? null : state.myPafRecord,
      };
    case types.APPRAISAL_ACTIVITY_LOGS_REQUEST:
      return {
        ...state,
        activityLogsLoading: true,
        activityLogsError: null,
      };
    case types.APPRAISAL_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        activityLogsLoading: false,
        activityLogs: {
          ...state.activityLogs,
          [action.appraisalProgressId]: {
            logs: action.logs,
            pagination: action.pagination,
          },
        },
        activityLogsError: null,
      };
    case types.APPRAISAL_ACTIVITY_LOGS_ERROR:
      return {
        ...state,
        activityLogsLoading: false,
        activityLogsError: action.error,
      };
    default:
      return state;
  }
};

export default AppraisalReducer;
